import { Component, OnInit } from '@angular/core';
import { DataSearchService } from 'src/app/services/data-search.service';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';


@Component({
  selector: 'app-latest-location-car',
  templateUrl: './latest-location-car.component.html',
  styleUrls: ['./latest-location-car.component.scss']
})
export class LatestLocationCarComponent implements OnInit {

  public geometry: any;
  public markers: any;

  constructor(public dataSearchService: DataSearchService,
              private router: Router,
              public appService: AppService) { }

  ngOnInit(): void {

    this.geometry = this.dataSearchService.geometry;
    this.markers = this.dataSearchService.markers;
        
  }

  public goLocationCar() {

    this.router.navigate(['location-car']);

  }

}
